var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.env != null)?_c('div',[_c('router-view',{attrs:{"env":_vm.env}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }